import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { AIAssistantUI } from './ai-assistant-ui.js';
import AiAssistantEditing from './ai-assistantediting.js';
import AICommandsUI from '../ai-commands/ai-command-ui.js';


export default class AIAssistant extends Plugin {

  static get requires() {
    return [AIAssistantUI, AiAssistantEditing, AICommandsUI];
  }

  static get pluginName() {
    return 'aiAssistant';
  }
}
